import React, { useEffect, useState } from 'react';
import classes from "./CategoryPage.module.css";
import { FaBarsStaggered, FaChevronLeft, FaChevronRight, FaStar, FaArrowRight } from 'react-icons/fa6';
import Lottie from 'lottie-react';
import stars from "../animations/stars3.json";
import { getContentApi, getVideosApi } from '../http/http';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Player/UI/Loader/Loader';
import Spinner from '../components/Player/UI/Loader/Spinner';
import CategoryCards from '../components/CategoryCards';
import { CONTENT_CATEGORIES } from '../constants/categories';
import TitleHeader from '../components/TitleHeader';
import DragCards from '../components/DragCards';
import SkeletonCardsLoading from '../components/SkeletonCardsLoading';
import TitleLoading from '../components/TitleLoading';

import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const CategoryPage = () => {
    const params = useParams();
    console.log(params, "params.....");

    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(true);

    const [magicKids, setMagicKids] = useState([]);
    const [humanCode, setHumanCode] = useState([]);
    const [rogueSports, setRogueSports] = useState([]);
    const [gameBox, setGameBox] = useState([]);

    const [loading, setLoading] = useState(false);

    const [magicKidsActive, setMagicKidsActive] = useState(1);
    const [humanCodeActive, setHumanCodeActive] = useState(6);
    const [rogueSportsActive, setRogueSportsActive] = useState(10);
    const [gameBoxActive, setGameBoxActive] = useState(14);

    const [humanCodeLoading, setHumanCodeLoading] = useState(false);
    const [gameBoxLoading, setGameBoxLoading] = useState(false);
    const [rogueSportsLoading, setRogueSportsLoading] = useState(false);
    const [magicKidsLoading, setMagicKidsLoading] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await getContentApi();
            console.log(response?.data, 'response---');
            setData(response?.data);
            setMagicKids(response?.data?.filter((item) => item?.main_category_id === 1));
            setHumanCode(response?.data?.filter((item) => item?.main_category_id === 2));
            setRogueSports(response?.data?.filter((item) => item?.main_category_id === 3));
            setGameBox(response?.data?.filter((item) => item?.main_category_id === 4));



            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error, "error");
        }
    };

    const changeHandler = (item, callback1, callback2) => {
        callback1(true);
        callback2(item);
        setTimeout(() => {
            callback1(false);
        }, 500);
    }

    useEffect(() => {
        fetchData();
    }, [params]);

    const shuffle = (arr = []) => {
        const a = [...arr];
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    };

    const randomGames = React.useMemo(() => {
        const gameBox = data?.find((x) => Number(x?.main_category_id) === 4);

        const allGames =
            gameBox?.sub_category
                ?.flatMap((sub) =>
                    (sub?.sub_category_videos_list || [])
                        .filter((g) => g?.type === "game")
                        .map((g) => ({
                            ...g,
                            sub_category_id: sub?.sub_category_id,
                            sub_category_name: sub?.sub_category_name,
                            main_category_id: gameBox?.main_category_id,
                            main_category_name: gameBox?.main_category_name,
                        }))
                ) || [];

        return shuffle(allGames).slice(0, 12); // show 12 random games
    }, [data]);

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}
                        onClick={() => {
                            navigate("/");
                        }}
                    >
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                </nav>

            </header>

            <section className={classes.main}>
                {/* <img src="/assets/images/Union.png" alt="union" className={classes.union_image} /> */}
                {/* <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} /> */}


                {/* <Lottie
                    animationData={stars}
                    loop={true}
                    autoplay={true}
                    initialSegment={[0, 100]}
                    className={classes.background_animation}
                /> */}

                {loading ?
                    <>
                        <TitleLoading />
                        <SkeletonCardsLoading />
                        <TitleLoading />
                        <SkeletonCardsLoading />
                    </>
                    : (
                        <>
                            <TitleHeader title={`Explore Little Masters`} data={data?.[0]?.sub_category}
                                mainData={data?.[0]}
                                active={magicKidsActive}
                                activateHandler={(item) => {
                                    changeHandler(item, setMagicKidsLoading, setMagicKidsActive)
                                }}
                            />
                            {magicKidsLoading ? <SkeletonCardsLoading /> :
                                <DragCards
                                    data={data?.[0]?.sub_category?.filter((item) => item?.sub_category_id === magicKidsActive)?.[0].sub_category_videos_list}
                                    category={data?.[0]}

                                    main_category_id={data?.[0]?.main_category_id}
                                    sub_category_id={data?.[0]?.sub_category?.filter((item) => item?.sub_category_id === magicKidsActive)?.[0]?.sub_category_id}
                                />
                            }

                                <section className={classes.guessWordSection}>
                                <div className={classes.guessWordInner}>
                                    {/* Left */}
                                    <div className={classes.guessWordLeft}>
                                        <div className={classes.guessWordTag}>New Game</div>

                                        <h2 className={classes.guessWordTitle}>
                                            Guess The <span>Word</span>
                                        </h2>

                                        <p className={classes.guessWordDesc}>
                                            A fun word puzzle for kids! Look at the picture, choose the correct letters,
                                            and complete the word. Improve spelling, memory, and vocabulary in a playful way.
                                        </p>

                                        <div className={classes.guessWordStats}>
                                            <div className={classes.statBox}>
                                                <div className={classes.statNum}>1000+</div>
                                                <div className={classes.statLabel}>Words</div>
                                            </div>
                                            <div className={classes.statBox}>
                                                <div className={classes.statNum}>3</div>
                                                <div className={classes.statLabel}>Difficulty Levels</div>
                                            </div>
                                        </div>

                                        <div className={classes.guessWordActions}>
                                            <button
                                                type="button"
                                                className={classes.primaryBtn}
                                                onClick={() => navigate("/word-game-details")}
                                            >
                                                Play Now
                                                <span className={classes.arrow}><FaArrowRight className={classes.arrow_icon} /></span>
                                            </button>

                                            {/* <button
                                                                    type="button"
                                                                    className={classes.secondaryBtn}
                                                                    onClick={() => navigate("/category/gaming")}
                                                                >
                                                                    Explore More Games
                                                                </button> */}
                                        </div>
                                    </div>

                                    {/* Right */}
                                    {/* <div className={classes.guessWordRight}> */}
                                    {/* <div className={classes.gameCard}> */}

                                    {/* <img src="/assets/images/guess-word.png" alt="guess word" className={classes.guessWordImage} /> */}

                                    {/* <div className={classes.gameCardTop}>
                                                                    <div className={classes.gameIcon}>🔤</div>
                                                                    <div>
                                                                        <div className={classes.gameName}>Guess The Word</div>
                                                                        <div className={classes.gameHint}>Hint: It’s a fruit 🍎</div>
                                                                    </div>
                                                                </div>
                            
                                                                <div className={classes.wordRow}>
                                                                    <span className={classes.letterBox}>A</span>
                                                                    <span className={classes.letterBox}>P</span>
                                                                    <span className={classes.letterBox}>_</span>
                                                                    <span className={classes.letterBox}>L</span>
                                                                    <span className={classes.letterBox}>E</span>
                                                                </div>
                            
                                                                <div className={classes.choicesRow}>
                                                                    <button className={classes.choiceChip} type="button">P</button>
                                                                    <button className={classes.choiceChip} type="button">E</button>
                                                                    <button className={classes.choiceChip} type="button">A</button>
                                                                    <button className={classes.choiceChip} type="button">M</button>
                                                                </div>
                            
                                                                <div className={classes.cardFooter}>
                                                                    <div className={classes.progressWrap}>
                                                                        <div className={classes.progressText}>Level 1</div>
                                                                        <div className={classes.progressBar}>
                                                                            <div className={classes.progressFill} />
                                                                        </div>
                                                                    </div>
                            
                                                                    <button
                                                                        type="button"
                                                                        className={classes.cardPlayBtn}
                                                                        onClick={() => navigate("/games/guess-the-word")}
                                                                    >
                                                                        Start
                                                                    </button>
                                                                </div> */}
                                    {/* </div> */}

                                    {/* <img src="/assets/images/guess-word.png" alt="guess word" className={classes.guessWordImage} /> */}


                                    <div className={classes.kidsDrawingRight}>
                                        <div className={classes.drawingPreviewCard}>
                                            <div className={classes.drawingTop}>
                                                <div className={classes.drawingIcon}>🎨</div>
                                                <div>
                                                    <div className={classes.drawingName}>Word Whirl</div>
                                                    <div className={classes.drawingSub}>Guess • Learn • Play</div>
                                                </div>
                                                {/* <div className={classes.drawingBadge}>STEP</div> */}
                                            </div>

                                            {/* Preview Image */}
                                            <div className={classes.drawingCanvas}>
                                                <img
                                                    src="/assets/images/guess-word.png"
                                                    alt="Drawing preview"
                                                    className={classes.drawingImg}
                                                />

                                                {/* Small steps chips */}
                                                {/* <div className={classes.stepChips}>
                                                                        <span className={classes.stepChip}>1</span>
                                                                        <span className={classes.stepChip}>2</span>
                                                                        <span className={classes.stepChip}>3</span>
                                                                    </div> */}
                                            </div>

                                            {/* Bottom */}
                                            <div className={classes.drawingFooter}>
                                                <div className={classes.drawingMeta}>
                                                    {/* <span>🕒 2–5 min</span> */}
                                                    {/* <span>⭐ Beginner</span> */}
                                                    <div className={classes.point}>🎮 Easy to play</div>
                                                    <div className={classes.point}>🧠 Brain boosting</div>
                                                    <div className={classes.point}>⭐ Difficulty Levels</div>
                                                </div>

                                                <button
                                                    type="button"
                                                    className={classes.drawingBtn}
                                                    onClick={() => navigate("/word-game-details")}
                                                >
                                                    Start Playing
                                                </button>
                                            </div>
                                        </div>

                                        {/* <div className={classes.drawBlobA} /> */}
                                        {/* <div className={classes.drawBlobB} /> */}
                                        {/* </div> */}

                                        <div className={classes.bubble1} />
                                        <div className={classes.bubble2} />
                                    </div>
                                </div>
                            </section>


                            <section className={classes.carousel_section}>
                                <TitleHeader title={`Popular Games`}
                                    hideFilter={true}
                                />
                                <div className={classes.carousel_sub_section}>
                                    <Swiper
                                        modules={[
                                            Autoplay,
                                            EffectCoverflow,
                                            Navigation
                                        ]}
                                        loop
                                        effect={"coverflow"}
                                        coverflowEffect={{
                                            slideShadows: false,
                                            rotate: 40
                                        }
                                        }
                                        spaceBetween={0}
                                        // slidesPerView={3}
                                        breakpoints={{
                                            0: {
                                                slidesPerView: 1,
                                                spaceBetween: 16,
                                            },
                                            640: {
                                                slidesPerView: 2,
                                                spaceBetween: 20,
                                            },
                                            1024: {
                                                slidesPerView: 3,
                                                spaceBetween: 0,
                                            },
                                        }}
                                        // slidesPerView={'auto'}
                                        autoplay={{
                                            delay: 1000,
                                            disableOnInteraction: false,
                                        }}
                                        navigation={{
                                            prevEl: ".custom-swiper-prev",
                                            nextEl: ".custom-swiper-next",
                                        }}
                                        onSwiper={(swiper) => null}
                                        onSlideChange={() => null}
                                    >
                                        {randomGames.map((game, idx) => (
                                            <SwiperSlide key={`${game?.id}-${idx}`}>
                                                <div
                                                    className={classes.carousel_item}
                                                    onClick={() =>
                                                        navigate(
                                                            `/game/${game?.name}?game=${game?.id}`
                                                            // `/category/content/${game?.main_category_name}?main_category_id=${game?.main_category_id}&sub_category_id=${game?.sub_category_id}&game_id=${game?.id}`
                                                        )
                                                    }
                                                >
                                                    <div className={classes.carousel_item_image}>
                                                        <img
                                                            src={game?.game_banner}
                                                            alt={game?.name}
                                                            className={classes.carousel_image}
                                                            loading="lazy"
                                                            onError={(e) => {
                                                                e.currentTarget.src = "/assets/images/thumbs/fallback.png";
                                                            }}
                                                        />

                                                        <button className={classes.carousel_item_button}>
                                                            {game?.sub_category_name}
                                                        </button>
                                                    </div>

                                                    <div className={classes.carousel_item_desc}>
                                                        <p className={classes.carousel_item_text}>{game?.name}</p>

                                                        <div className={classes.carousel_item_stars}>
                                                            {Array.from({ length: 5 }).map((_, i) => (
                                                                <FaStar key={i} className={classes.carousel_star_icon} />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>

                                    <div className={classes.carousel_navigation}>
                                        <button className={`custom-swiper-prev ${classes.nav_button}`}>
                                            <FaChevronLeft className={classes.carousel_star_icon2} />
                                        </button>

                                        <button className={`custom-swiper-next ${classes.nav_button}`}>
                                            <FaChevronRight className={classes.carousel_star_icon2} />
                                        </button>
                                    </div>
                                </div>
                            </section>


                            {/* Game Box */}

                            <TitleHeader title={`Explore Kids Games`} data={data?.[3]?.sub_category}
                                mainData={data?.[3]}
                                active={gameBoxActive}
                                activateHandler={(item) => {
                                    changeHandler(item, setGameBoxLoading, setGameBoxActive)
                                }}
                            />
                            {gameBoxLoading ? <SkeletonCardsLoading /> :
                                <DragCards

                                    data={data?.[3]?.sub_category?.filter((item) => item?.sub_category_id === gameBoxActive)?.[0].sub_category_videos_list}
                                    category={data?.[3]}

                                    main_category_id={data?.[3]?.main_category_id}
                                    sub_category_id={data?.[3]?.sub_category?.filter((item) => item?.sub_category_id === gameBoxActive)?.[0]?.sub_category_id}
                                />
                            }


                        

                            <section className={classes.ticTacSection}>
                                <div className={classes.ticTacInner}>
                                    {/* Left */}
                                    <div className={classes.ticTacLeft}>
                                        <div className={classes.ticTacTag}>Classic Game</div>

                                        <h2 className={classes.ticTacTitle}>
                                            Tic Tac <span>Toe</span>
                                        </h2>

                                        <p className={classes.ticTacDesc}>
                                            Play the timeless X-O game! Take turns, think ahead, and try to make three in
                                            a row. Great for improving logic, strategy, and quick thinking—super fun for kids.
                                        </p>

                                        <div className={classes.ticTacPoints}>
                                            <div className={classes.tPoint}>❌ Easy rules</div>
                                            <div className={classes.tPoint}>⭕ Brain & logic</div>
                                        </div>

                                        <div className={classes.ticTacActions}>
                                            <button
                                                type="button"
                                                className={classes.primaryBtn}
                                                onClick={() => navigate("/xo-game-details")}
                                            >
                                                Play Now <span className={classes.arrow}><FaArrowRight className={classes.arrow_icon} /></span>
                                            </button>

                                        </div>
                                    </div>

                                    {/* Right */}
                                    <div className={classes.ticTacRight}>
                                        {/* <div className={classes.ticTacCard}> */}
                                        {/* <div className={classes.ticTacTop}>
                                                                    <div className={classes.ticTacIcon}>❌⭕</div>
                                                                    <div>
                                                                        <div className={classes.ticTacName}>Tic Tac Toe</div>
                                                                        <div className={classes.ticTacSub}>Make 3 in a row</div>
                                                                    </div>
                                                                    <div className={classes.ticTacBadge}>VS</div>
                                                                </div>
                            
                                                                <div className={classes.board}>
                                                                    {Array.from({ length: 9 }).map((_, i) => (
                                                                        <div key={i} className={classes.cell}>
                                                                            {i === 0 ? "X" : i === 4 ? "O" : i === 8 ? "X" : ""}
                                                                        </div>
                                                                    ))}
                                                                </div>
                            
                                                                <div className={classes.ticTacFooter}>
                                                                    <div className={classes.turnPill}>Your turn: ❌</div>
                            
                                                                    <button
                                                                        type="button"
                                                                        className={classes.ticTacBtn}
                                                                        onClick={() => navigate("/games/tic-tac-toe")}
                                                                    >
                                                                        Start
                                                                    </button>
                                                                </div> */}
                                        {/* </div> */}

                                        <div className={classes.drawingPreviewCard}>
                                            <div className={classes.drawingTop}>
                                                <div className={classes.drawingIcon}>⭕</div>
                                                <div>
                                                    <div className={classes.drawingName}>Tic Tac Toe</div>
                                                    <div className={classes.drawingSub}>Fun • Exciting • Brainstorming</div>
                                                </div>
                                                {/* <div className={classes.drawingBadge}>STEP</div> */}
                                            </div>

                                            {/* Preview Image */}
                                            <div className={classes.drawingCanvas}>
                                                <img
                                                    src="/assets/images/tic-tac-toe.png"
                                                    alt="Drawing preview"
                                                    className={classes.drawingImg}
                                                />

                                                {/* Small steps chips */}
                                                {/* <div className={classes.stepChips}>
                                                                        <span className={classes.stepChip}>1</span>
                                                                        <span className={classes.stepChip}>2</span>
                                                                        <span className={classes.stepChip}>3</span>
                                                                    </div> */}
                                            </div>

                                            {/* Bottom */}
                                            <div className={classes.drawingFooter}>
                                                <div className={classes.drawingMeta}>
                                                    {/* <span>🕒 3 Levels</span> */}
                                                    {/* <span>⭐ Beginner</span> */}
                                                    <div className={classes.point}>🎮 Easy to play</div>
                                                    <div className={classes.point}>🧠 Brain boosting</div>
                                                </div>

                                                <button
                                                    type="button"
                                                    className={classes.drawingBtn}
                                                    onClick={() => navigate("/xo-game-details")}
                                                >
                                                    Start Playing
                                                </button>
                                            </div>
                                        </div>

                                        <div className={classes.ticBlobA} />
                                        <div className={classes.ticBlobB} />
                                    </div>
                                </div>
                            </section>

                        </>
                    )}





            </section>

        </main>
    )
}

export default CategoryPage